import { useContext } from "react";
import { createValidators } from "../utils/validationUtils";
import { LocaleContext } from "../contexts/LocaleContext";

export const useValidation = () => {
  const { t } = useContext(LocaleContext);

  return createValidators(t);
};
